<template>
  <div class="row mt-xl">
    <div class="col-md-7 col-6">
      <ReferralShareHeader :referral-code="referralCode"/>
      <ReferralShareLink :referral-code="referralCode"/>
    </div>
    <div class="col-md-5 col-6">
      <ReferralShareActions
        v-if="referralCampaign"
        :referral-url="`https://www.armoire.style/refer/${referralCode}`"
        :referral-campaign="referralCampaign"/>
      <TextLink
        class="d-block text-center mt-xl"
        target="_blank"
        type="a"
        href="https://support.armoire.style/legal/">
        Terms & Conditions
      </TextLink>
    </div>
  </div>
</template>

<script setup>
import ReferralShareHeader from './ReferralShareHeader.vue'
import ReferralShareLink from './ReferralShareLink.vue'
import ReferralShareActions from './ReferralShareActions.vue'
import TextLink from '../global/sequin/TextLink.vue'

defineProps({
  referralCode: {
    type: String,
    required: true
  },
  referralCampaign: {
    type: Object,
    required: true
  }
})
</script>
